'use client'
import { Button } from "@mui/material";
import {styled as muiStyled} from '@mui/material/styles';

const buttonCommonStyle = {
    fontSize: '14px',
    padding: '7px 16px',
    borderRadius: '4px',
    lineHeight: '18px',
    textAlign: 'center',
    fontWeight: 400
}

// @ts-ignore
export const SubmitButton = muiStyled(Button)(({theme}) => (
    {
        ...buttonCommonStyle,
        background: "#CC0C1C",
        color: '#fff',
        // backgroundColor: '#999',
        '&:hover': {
            background: "#990915",
            boxShadow: 'none',
        },
        '&.Mui-disabled': {
            opacity: 0.5,
            cursor: 'no-drop',
            color: "#FF9FA7"
        }
    }
));

// @ts-ignore
export const CancelButton = muiStyled(Button)(({theme}) => (
    {
        ...buttonCommonStyle,
        border: '1px solid rgba(224, 225, 229, 1)',
        color: 'rgba(26, 26, 26, 1)',
        // backgroundColor: '#999',
        '&:hover': {
            background: 'none',
            boxShadow: 'none',
        },
        '&.Mui-disabled': {
            opacity: 0.5,
            cursor: 'no-drop',
            color: '#fff'
        }
    }
));
